import React from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, IconButton, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslate } from 'react-admin';

import imageInfo from '../../assets/infochanges.png'
import { Close } from '@material-ui/icons';
import TextButton from '../../CustomizedUIs/TextButton';
import CloseButton from '../../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
    container: {
        width: 450,
        textAlign: 'center',
        backgroundColor: '#f3f7fa',
        paddingBottom: theme.spacing(5)
    },
    image: {
        width: '250px',
        marginTop: 32,
        marginBottom: 55
    },
    textClose: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.4px',
        color: '#4f5064',
    },
    BorderClose: {
        width: '25px',
        height: '25px',
        border: 'solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
        marginLeft: '10px',
        padding: 0
    },
    TitleUnSave: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '22px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '27.5px',
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    ContentUnSave: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '15px',
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
        paddingTop: '10px'
    },

}));

function CustomizeContentDialog({ confirm }) {
    const { action, open, title, content } = confirm;
    const classes = useStyles();
    const translate = useTranslate();

    return (
        <Dialog open={open} onClose={action.onClose} aria-labelledby="form-dialog-title" >
            <Box className={classes.container}>
                <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                    <Typography className={classes.textClose}>{translate(`pos.common.close`)}</Typography>

                    <CloseButton onClick={action.onClose ? action.onClose : action.onCancel} />
                </Box>
                <img alt='image-save' src={imageInfo} className={classes.image} />
                <Typography className={classes.TitleUnSave}>{title}</Typography>
                <Typography className={classes.ContentUnSave}>{content}</Typography>
                <Box mt={3}>
                    <TextButton
                        style={{ marginTop: 16, marginRight: 20 }}
                        onClick={action.onCancel}
                    />
                    <Button
                        variant='contained'
                        color='primary'
                        size='large'
                        onClick={action.onClick}
                    >
                        {action.label}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    )
}

CustomizeContentDialog.propTypes = {
    confirm: PropTypes.shape({
        open: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
        action: PropTypes.shape({
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            onCancel: PropTypes.func.isRequired,
            onClose: PropTypes.func.isRequired,
        }),
    }).isRequired
};

export default CustomizeContentDialog;
